import { EditAutoPaymentMethodDialogStep } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/types/EditAutoPaymentMethodDialogStep';

export const EDIT_AUTO_PAYMENT_METHOD_STEP_TITLE_TEXT_ID: Record<EditAutoPaymentMethodDialogStep, string> = {
  [EditAutoPaymentMethodDialogStep.VEHICLE]: 'EDIT_VEHICLE_DATA',
  [EditAutoPaymentMethodDialogStep.SIMULATOR]: 'EDIT_FINANCING_DETAILS',
  [EditAutoPaymentMethodDialogStep.CHANGES_REVIEW]: 'CHANGES_REVIEW',
};
